import { useQueryClient } from '@tanstack/react-query'
import { $api } from '../api/queryClient'

export const METER_SUPPLY_PATH = '/api/v1/organizations/{orgCode}/assets/{assetUid}/meter-supply' as const

/**
 * The supply coverage of a meter, or with `subtree` of every meter under an
 * asset (spec 2026-10-27-16). The Equipment tab reads the subtree once for its
 * chips; a meter's own card reads just that meter.
 */
export function useMeterSupply(org: string, assetUid: string, options: { subtree?: boolean; enabled?: boolean } = {}) {
  const { subtree = false, enabled = true } = options
  return $api.useQuery(
    'get',
    METER_SUPPLY_PATH,
    { params: { path: { orgCode: org, assetUid }, query: { subtree } } },
    { enabled: enabled && !!org && !!assetUid, retry: false },
  )
}

/** Refreshes every meter-supply reading after a contract was linked or filed. */
export function useInvalidateMeterSupply() {
  const queryClient = useQueryClient()
  return () =>
    queryClient.invalidateQueries({
      predicate: (q) => q.queryKey[0] === 'get' && q.queryKey[1] === METER_SUPPLY_PATH,
    })
}
